// extracted by mini-css-extract-plugin
export default {"UpdateEnemy":"UpdateEnemy_UpdateEnemy__F7aqM","form":"UpdateEnemy_form__Z3ko1"};